namespace $.$$ {

	export class $bog_ui_sheet extends $.$bog_ui_sheet {

		@ $mol_action
		backdrop_click( next?: any ) {
			if( next !== undefined ) {
				this.showed( false )
			}
			return null
		}

	}

}
